import React from "react";
import DecodeText from "../components/DecodeText";
import MorphLink from "../components/MorphLink";

const Home: React.FC = () => {
  const currentText =
    "i’m akshay, a software engineer at meta building ai for advertisers across memory, personalization, and multimodal generation. previously, at scale ai, i helped power frontier ai development across agents, tool use, and the data infrastructure behind them. before that, i worked on enterprise generative ai at typeface.";
  const backgroundText =
    "i studied engineering and business through uc berkeley’s m.e.t. program. i also work with early-stage founders through pear vc and pantera capital. outside of work, i like exploring the bay area, trying new tech, and watching fc barcelona.";

  return (
    <div className="minimal-home">
      <section className="minimal-intro" aria-labelledby="intro-title">
        <DecodeText
          as="h1"
          text="hi, i’m akshay."
          delay={80}
          duration={1200}
        >
          <span id="intro-title">hi, i’m akshay.</span>
        </DecodeText>

        <div className="bio-copy">
          <DecodeText text={currentText} delay={1350} duration={2500}>
            i’m akshay, a software engineer at meta building ai for advertisers
            across memory, personalization, and multimodal generation.
            previously, at{" "}
            <a href="https://scale.com/" target="_blank" rel="noreferrer">
              scale ai
            </a>
            , i helped power frontier ai development across agents, tool use,
            and the data infrastructure behind them. before that, i worked on
            enterprise generative ai at{" "}
            <a href="https://www.typeface.ai/" target="_blank" rel="noreferrer">
              typeface
            </a>
            .
          </DecodeText>
          <DecodeText text={backgroundText} delay={3950} duration={2500}>
            i studied engineering and business through uc berkeley’s{" "}
            <a href="https://met.berkeley.edu/" target="_blank" rel="noreferrer">
              m.e.t. program
            </a>
            . i also work with early-stage founders through{" "}
            <a href="https://www.pear.vc/" target="_blank" rel="noreferrer">
              pear vc
            </a>{" "}
            and{" "}
            <a
              href="https://panteracapital.com/"
              target="_blank"
              rel="noreferrer"
            >
              pantera capital
            </a>
            . outside of work, i like exploring the bay area, trying new tech,
            and watching fc barcelona.
          </DecodeText>
        </div>

        <div className="intro-links">
          <MorphLink href="mailto:akshaypatel.y@gmail.com">email</MorphLink>
          <MorphLink
            href="https://www.linkedin.com/in/akshay-patel-/"
            target="_blank"
            rel="noreferrer"
          >
            linkedin
          </MorphLink>
          <MorphLink
            href="https://github.com/akshay-patel-y"
            target="_blank"
            rel="noreferrer"
          >
            github
          </MorphLink>
        </div>
      </section>
    </div>
  );
};

export default Home;
